import type { FreehandElement } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase, stroke } from '../../registry/factoryShared';

export function createFreehandElement(
  config: BaseElementConfig & {
    pathData: string;
    strokeColor: string;
    strokeWidth: number;
  },
): FreehandElement {
  return {
    ...createBase('freehand', {
      ...config,
      appearance: {
        ...config.appearance,
        strokes: [stroke(config.strokeColor, config.strokeWidth, 'solid')],
      },
    }),
    data: { pathData: config.pathData },
  };
}
